import { render, staticRenderFns } from "./PatentSearchDatabaseForm.vue?vue&type=template&id=cbbd8b2c&"
import script from "./PatentSearchDatabaseForm.vue?vue&type=script&lang=js&"
export * from "./PatentSearchDatabaseForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentSearchDatabaseForm.vue?vue&type=style&index=0&id=cbbd8b2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports